import {
  constants,
  mediaQueryStyles,
  typographyStyles,
} from "@newsela/angelou";

import { fullGradientColors } from "@/components/AIComponents/AiComponents.style";

import {
  powerWordButtonBorderBottomWidths,
  powerWordButtonBottomPaddings,
  powerWordButtonIconHeights,
  powerWordButtonIconWidths,
  powerWordPopOutIconSizes,
} from "@/view/constants/styles/accessibleFontSizeMapping/accessibleFontSizeMapping.style";

const { colors } = constants;
const { mediaQuery: breakpoint } = mediaQueryStyles;

const coreBlue = colors.ui.core[100];
const darkBlue = colors.ui.core[700];
const neutral700 = colors.ui.neutral[700];
const white = colors.ui.white[500];

const { textXSObj } = typographyStyles;

const getIconSize = (currentFontSize) =>
  powerWordPopOutIconSizes[currentFontSize];

export const rootCss = (accessibleFontSize) => ({
  display: "inline-block",
  color: neutral700,
  fontSize: "inherit",
  fontWeight: "bold",

  [breakpoint.downTo("xs")]: {
    fontSize: "inherit",
  },

  // The first span inside of the button is the button text
  // aka the key term
  'button[aria-expanded="true"] span:first-of-type, &:hover button span:first-of-type':
    {
      borderColor: darkBlue,
    },

  // Key term question mark icon
  'button[aria-expanded="true"] svg, &:hover button svg': {
    backgroundColor: darkBlue,
    path: {
      stroke: white,
      fill: darkBlue,
    },
  },

  span: {
    display: "inline-block",
    position: "relative",
    paddingBottom: powerWordButtonBottomPaddings[accessibleFontSize],
    marginLeft: 0,
    borderBottom: `${powerWordButtonBorderBottomWidths[accessibleFontSize]} solid ${coreBlue}`,
  },
});

export const keyTermIconCss = (accessibleFontSize) => ({
  display: "block",
  backgroundColor: coreBlue,
  width: powerWordButtonIconWidths[accessibleFontSize],
  height: `${powerWordButtonIconHeights[accessibleFontSize]}px`,
  padding: "1px",
  path: {
    stroke: white,
    strokeWidth: "4.5px",
  },
});

// DIALOG STYLES

export const dialogContainerCss = {
  maxWidth: "359px",
  minHeight: "146px",
  zIndex: 2,
  padding: 0,
  border: `1px solid ${fullGradientColors.position100.color}`,
};

export const closeButtonCss = {
  top: "9px",
  right: "10px",
};

export const closeIconCss = (accessibleFontSize) => ({
  height: getIconSize(accessibleFontSize),
  width: getIconSize(accessibleFontSize),
});

export const headerCss = {
  ...textXSObj,
  padding: "16px 0 12px 12px",
  letterSpacing: "1px",
  textTransform: "uppercase",
};

export const tooltipArrowCss = {
  ":before": {
    width: "11px",
    height: "11px",
    borderColor: fullGradientColors.position100.color,
  },
};
